module.exports = __webpack_public_path__ + "img/academy-image-min.b57b88d8.jpg";